(function() {
  document.addEventListener('DOMContentLoaded', function() {

    function formatMoney(cents) {
      var francs = (cents / 100).toFixed(2);
      return 'CHF ' + francs.replace('.00', '.–');
    }

    function getItemLineTotalCents(item) {
      var q = item.quantity || 1;
      if (item.properties && item.properties['_bundle_price'] === '159.00') {
        return Math.floor(q / 3) * 15900 + (q % 3) * 6900;
      }
      if (q >= 3) {
        return Math.floor(q / 3) * 15900 + (q % 3) * 6900;
      }
      return q * 6900;
    }

    function getItemUnitPriceCents(item) {
      var q = item.quantity || 1;
      if (q >= 3 || (item.properties && item.properties['_bundle_price'] === '159.00')) {
        return Math.round(getItemLineTotalCents(item) / q);
      }
      return 6900;
    }

    function updateCartUI(cart) {
      var subtotalCents = 0;
      var count = cart.item_count || 0;

      if (cart.items && cart.items.length > 0) {
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          subtotalCents += getItemLineTotalCents(it);
        }
      } else {
        subtotalCents = cart.items_subtotal_price || cart.total_price || 0;
      }

      var shippingCents = count > 0 ? 1000 : 0;
      var totalCents = subtotalCents + shippingCents;

      var subtotalEl = document.getElementById('cartSubtotal');
      var totalEl = document.getElementById('cartTotal');
      var countEl = document.getElementById('cartCountBadge');
      var progressBar = document.getElementById('cartProgressFill');
      var progressMsg = document.getElementById('cartProgressMsg');

      if (subtotalEl) subtotalEl.textContent = formatMoney(subtotalCents);
      if (totalEl) totalEl.textContent = formatMoney(totalCents);
      if (countEl) countEl.textContent = count + ' ' + (count === 1 ? 'Artikel' : 'Artikel');

      if (progressBar) {
        var pct = count > 0 ? 100 : 0;
        progressBar.style.width = pct + '%';
      }
      if (progressMsg) {
        if (count > 0) {
          progressMsg.innerHTML = '🚚 <strong>Schweizer Post Expressversand:</strong> CHF 10.– (1-2 Werktage)';
        } else {
          progressMsg.innerHTML = '🚚 Schweizer Post Expressversand: CHF 10.– in die ganze Schweiz';
        }
      }

      if (count === 0) {
        window.location.reload();
      }
    }

    function updateLineItem(line, qty) {
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        updateCartUI(cart);
        // Find line item card and update quantity / line price
        var itemCard = document.querySelector('.cart-item-card[data-line="' + line + '"]');
        if (itemCard) {
          if (qty === 0) {
            itemCard.remove();
          } else {
            var qtyVal = itemCard.querySelector('.cart-qty-val');
            var lineTotal = itemCard.querySelector('.cart-item-total');
            var unitPriceEl = itemCard.querySelector('.cart-item-unit-price');
            if (qtyVal) qtyVal.textContent = qty;
            
            // Find line item price in cart.items
            if (cart.items && cart.items[line - 1]) {
              var item = cart.items[line - 1];
              item.quantity = qty;
              var lineTotalCents = getItemLineTotalCents(item);
              var unitPriceCents = getItemUnitPriceCents(item);
              if (unitPriceEl) unitPriceEl.textContent = formatMoney(unitPriceCents);
              if (lineTotal) lineTotal.textContent = formatMoney(lineTotalCents);
            }
          }
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function(err) {
        console.error('Error updating cart:', err);
      });
    }

    // Attach quantity minus / plus / remove listeners
    document.querySelectorAll('.cart-item-card').forEach(function(card) {
      var line = parseInt(card.dataset.line, 10);
      var btnMinus = card.querySelector('.cart-qty-minus');
      var btnPlus = card.querySelector('.cart-qty-plus');
      var btnRemove = card.querySelector('.cart-remove-btn');
      var qtyVal = card.querySelector('.cart-qty-val');

      if (btnMinus && qtyVal) {
        btnMinus.addEventListener('click', function() {
          var current = parseInt(qtyVal.textContent, 10) || 1;
          if (current > 1) {
            updateLineItem(line, current - 1);
          } else {
            updateLineItem(line, 0);
          }
        });
      }

      if (btnPlus && qtyVal) {
        btnPlus.addEventListener('click', function() {
          var current = parseInt(qtyVal.textContent, 10) || 1;
          updateLineItem(line, current + 1);
        });
      }

      if (btnRemove) {
        btnRemove.addEventListener('click', function() {
          updateLineItem(line, 0);
        });
      }
    });

  });
})();
